import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { map, keyBy } from "lodash/fp";
import { tensorGridContext } from "./tensor-grid-context.es.js";
import { TensorGridItem } from "./tensor-grid-item.es.js";
import { TensorGridImpl, TensorGridHeader } from "./tensor-grid.styles.es.js";
import { tensorize } from "../../utils/tensorize.es.js";
const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func
};
const defaultProps = {
  onChange: void 0
};
const TensorGrid = ({ columns, data, onChange }) => {
  const { column, items } = useMemo(
    () => tensorize(map("dataKey", columns), data),
    [columns, data]
  );
  const columnsContext = useMemo(() => keyBy("dataKey", columns), [columns]);
  const [editMode, setEditMode] = useState(false);
  return /* @__PURE__ */ jsx(tensorGridContext.Provider, { value: columnsContext, children: /* @__PURE__ */ jsxs(TensorGridImpl, { $numberOfColumns: columns.length, children: [
    columns.map((col, i) => /* @__PURE__ */ jsx(
      TensorGridHeader,
      {
        $firstColumn: i === 0,
        $lastColumn: i === columns.length - 1,
        children: col.label
      },
      col.dataKey
    )),
    /* @__PURE__ */ jsx(
      TensorGridItem,
      {
        column,
        editMode,
        firstColumn: true,
        items,
        lastRow: true,
        onChange,
        onEditModeChange: setEditMode
      }
    )
  ] }) });
};
TensorGrid.propTypes = propTypes;
TensorGrid.defaultProps = defaultProps;
export {
  TensorGrid
};
